"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.498 0a2.516 2.516 0 0 1 2.496 2.336L24 2.5v8c0 .607-.214 1.177-.604 1.624l-.137.145-10.994 10.995c-.41.42-.97.68-1.558.728l-.224.008a2.473 2.473 0 0 1-1.61-.605l-.143-.135-7.993-7.996A2.447 2.447 0 0 1 0 13.499c0-.61.214-1.179.606-1.626l.137-.144.148-.137L11.605.876l.047-.055.087-.088a2.453 2.453 0 0 1 1.55-.725L13.487 0h8.012ZM18.6 2.999a2.001 2.001 0 1 0 .003 4.003 2.001 2.001 0 0 0-.003-4.003Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};